import { ProductTypes } from "@/lib/centra/productFetcher";
import Image from "next/image";
import styles from "./cart-image.module.css";
type ImageProps = {
  image: string;
  alt: string;
  type: ProductTypes;
};

const CartImage = ({ image, alt, type }: ImageProps) => {
  if (type === "recipe" || type === "booklet") {
    return (
      <div className={styles["cart-image"]}>
        <Image
          src={image}
          alt={alt}
          objectFit="contain"
          width={55}
          height={78}
        />
      </div>
    );
  }
  return (
    <Image src={image} alt={alt} width={80} height={100} objectFit="contain" />
  );
};

export default CartImage;
